/* NIBBLE & NABBLE — GLOBAL JS */
(function () {
  'use strict';

  var nav = document.getElementById('nn-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var mt = document.getElementById('nn-mobile-toggle');
  var mm = document.getElementById('nn-mobile-menu');
  if (mt && mm) {
    mt.addEventListener('click', function () {
      var open = mm.classList.toggle('open');
      mt.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  var cartTrigger = document.getElementById('nn-cart-trigger');
  var cartDrawer = document.getElementById('nn-cart-drawer');
  var cartOverlay = document.getElementById('nn-cart-overlay');
  var cartClose = document.getElementById('nn-cart-close');

  function openCart() { cartDrawer && cartDrawer.classList.add('open'); cartOverlay && cartOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { cartDrawer && cartDrawer.classList.remove('open'); cartOverlay && cartOverlay.classList.remove('open'); document.body.style.overflow = ''; }

  cartTrigger && cartTrigger.addEventListener('click', openCart);
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  window.NibbleNabble = window.NibbleNabble || {};
  window.NibbleNabble.openCart = openCart;
  window.NibbleNabble.closeCart = closeCart;

  var dismiss = document.getElementById('nn-announcement-dismiss');
  dismiss && dismiss.addEventListener('click', function () {
    var bar = document.getElementById('nn-announcement');
    bar && bar.remove();
  });

  var reveal = document.querySelectorAll('[data-reveal]');
  if (reveal.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('revealed'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    reveal.forEach(function (el) { obs.observe(el); });
  }

  var rec = document.querySelector('.nn-recommendations');
  if (rec) {
    var pid = rec.dataset.productId, limit = rec.dataset.limit, base = rec.dataset.url;
    fetch(base + '?section_id=&product_id=' + pid + '&limit=' + limit)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var products = tmp.querySelectorAll('.nn-product-card, .grid__item, .product-card');
        var grid = document.getElementById('nn-recommendations-grid');
        if (grid && products.length) { products.forEach(function (p) { grid.appendChild(p); }); }
        else if (grid) { rec.style.display = 'none'; }
      })
      .catch(function () { rec.style.display = 'none'; });
  }
})();

/* ── 2.0 additions ── */
(function () {
  'use strict';

  /* Sticky mobile ATC: show after scrolling past main button */
  var sticky = document.getElementById('nn-sticky-atc');
  var mainAtc = document.querySelector('.nn-product__atc');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(mainAtc);
  }

  /* Newsletter inline success morph */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.nn-footer__email-form, .nn-find-us__form, .nn-find-us-strip__form');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input[type="email"]');
    if (!input || !input.value || input.value.indexOf('@') < 0) {
      window.NibbleNabble && window.NibbleNabble.toast && window.NibbleNabble.toast('Enter a valid email', true);
      return;
    }
    f.classList.add('is-done');
    var btn = f.querySelector('button');
    if (btn) btn.textContent = '\u2713';
    input.disabled = true;
    window.NibbleNabble && window.NibbleNabble.toast && window.NibbleNabble.toast('You\u2019re on the list!');
  });

  /* Testimonials auto-rotating carousel */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('.nn-testimonials[data-carousel]:not([data-carousel-init])').forEach(function (sec) {
      sec.dataset.carouselInit = '1';
      var cards = sec.querySelectorAll('.nn-testimonial');
      if (cards.length < 2) return;
      var grid = cards[0].parentElement;
      grid.style.display = 'block';
      var dots = document.createElement('div');
      dots.className = 'nn-testimonials__dots';
      var idx = 0, timer = null;
      cards.forEach(function (card, i) {
        card.style.display = i === 0 ? '' : 'none';
        var d = document.createElement('button');
        d.className = 'nn-testimonials__dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Testimonial ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dots.appendChild(d);
      });
      grid.after(dots);
      function go(i) {
        cards[idx].style.display = 'none';
        dots.children[idx].classList.remove('active');
        idx = i % cards.length;
        cards[idx].style.display = '';
        dots.children[idx].classList.add('active');
      }
      function restart() { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 5000); }
      restart();
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
